import omit from 'lodash-es/omit';
import { BillingStatus, NetworkType, OptionCode, OrgRole } from '../../enums';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedOrg = {
    id: 1,
    activeOptions: [OptionCode.sms100],
    billingStatus: BillingStatus.plus,
    createdAt: '0',
    invoicedOrganizationId: 0,
    name: 'orga test',
    membershipCode: null,
    myRole: OrgRole.admin,
    networkType: NetworkType.distribution,
    ownerFullName: 'Test',
    subscribedNetworkId: NetworkType.distribution,
    virtualDevicesCount: 1,
    virtualDevicesQuota: 5,
    companyName: 'My Company',
    city: 'Nantes',
    addressLine1: '2 Imp. Thérèse Bertrand-Fontaine',
    addressLine2: '',
    zipCode: '44300',
    countryCode: 'FR',
    headquarter: {
        name: 'my_location',
        lat: -1,
        lng: 12
    },
    siret: '12356894100056',
    trial: null,
    network: null
};
const manyOrgs = [omit(mockedOrg, 'virtualDevicesCount', 'virtualDevicesQuota')];
const mock = {
    leave: mockedRequester(undefined, 'orgs.leave'),
    update: mockedRequester(mockedOrg, 'orgs.update'),
    get: mockedRequester(mockedOrg, 'orgs.get'),
    getAllPages: mockedRequester(manyOrgs, 'orgs.getAllPages'),
    getMany: mockedRequester(mockedPaginatedResponse(manyOrgs), 'orgs.getMany')
};
export default mock;
